// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stockId: __t.u64().primaryKey().name("stock_id"),
  settlementId: __t.u64().name("settlement_id"),
  commodity: __t.string(),
  qty: __t.f32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
